import * as React from 'react'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import useTheme from '@mui/material/styles/useTheme'
import { TextFieldProps } from '@mui/material/TextField'
import { CalendarDatePicker } from '@user/components/CalendarButton'
import { useData, useHandlers } from './hooks'
import { useFormikContext } from 'formik'
import { ILeadFormModel } from '@user/components/Leads/AddLeadForm/typings'
import Paper from '@mui/material/Paper'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'

type Props = {
  fieldName: string
  hideOptional: boolean
  textFieldProps?: TextFieldProps
}

export function NextActionDate(props: Props) {
  const { fieldName, hideOptional } = props

  const { errorText, hasError, requiredNextActionDate, showNextActionDate } =
    useData({ fieldName, hideOptional })

  const { handleAccept } = useHandlers({ fieldName })

  const { values } = useFormikContext<ILeadFormModel>()

  const theme = useTheme()

  const { getFormat } = useLocalizationDateFormat()

  return showNextActionDate ? (
    <Paper
      elevation={0}
      sx={{
        padding: theme.spacing(1, 2, 1, 2),
        overflow: 'visible',
        border: 'solid 1px #e0e0e0',
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle2">
          Next Action Date{requiredNextActionDate && ' *'}
        </Typography>
        <CalendarDatePicker
          value={values[fieldName]}
          onAccept={handleAccept}
          format={getFormat()}
          color="#1565c0"
          dataTestId="next-action-date-picker"
        />
      </Stack>
      {hasError && (
        <Typography variant="caption" color="error" mb={1} mt={1}>
          {errorText}
        </Typography>
      )}
    </Paper>
  ) : null
}
